module.exports = __webpack_public_path__ + "img/villi.4a09d77c.svg";